// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The federated result list, which replaces the card grid while searching.
 *
 * It reuses \`.cardGrid\` for the scroll behaviour, gutters and scrollbar - the
 * shared stylesheet owns all of that - and overrides only the track, because
 * results are rows rather than tiles. A bordered box hugs its rows rather than
 * stretching to the bottom of the column, and scrolls once it reaches it.
 */
._NL613GS99TLh6cMi2_R {
  display: block;
  flex: 0 1 auto;
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  padding: 0;
  margin: var(--catalogBrowseCardGridPadding, 16px);
  overflow: hidden auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/discovery/DiscoveryCatalogBrowse.module.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;AACF;EACE,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,UAAU;EACV,iDAAiD;EACjD,qBAAqB;AACvB","sourcesContent":["/*\n * The federated result list, which replaces the card grid while searching.\n *\n * It reuses `.cardGrid` for the scroll behaviour, gutters and scrollbar - the\n * shared stylesheet owns all of that - and overrides only the track, because\n * results are rows rather than tiles. A bordered box hugs its rows rather than\n * stretching to the bottom of the column, and scrolls once it reaches it.\n */\n.resultList {\n  display: block;\n  flex: 0 1 auto;\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  padding: 0;\n  margin: var(--catalogBrowseCardGridPadding, 16px);\n  overflow: hidden auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resultList": `_NL613GS99TLh6cMi2_R`
};
export default ___CSS_LOADER_EXPORT___;
